module.exports = __webpack_public_path__ + "img/mes5.7435de59.png";